import { SoftDeleteEntity } from './soft-delete-entity';
import { PaymentImport } from './payment-import';
import {Invoice} from './invoice';

export class Payment extends SoftDeleteEntity {
    public date: Date;
    public amount: number;
    public paymentImportId: number;
    public orderId: number;
    public token: number;
    public importErrorsText: string;

    public invoiceId: number;

   public isSentToPairFinance: boolean;
}
